<template>
  <div class="select-language">
    <h2 class="select-language-title" v-if="!loading">
      ¿Cuál idioma deseas aprender?
    </h2>

    <v-skeleton-loader type="text" class="sk-title" v-else></v-skeleton-loader>

    <!-- <div>
            <pre v-if="selectedLanguage">
                Idioma seleccionado: {{ selectedLanguage.name }}
            </pre>
            <pre v-if="selectedProgram">
                Programa seleccionado: {{ selectedProgram.name }}
            </pre>


            <pre>
                <v-btn
                    color="primary"
                    class="btn-basic uppercase"
                    v-if="selectedLanguage && selectedProgram"
                    @click="next"
                    >
                    Continuar
                </v-btn>
            </pre>

        </div> -->

    <div
      class="language-list"
      ref="languageList"
      v-if="!loading && languages.length"
    >
      <div
        v-for="(lng, index) in languages"
        :key="index"
        @click="onFlagEnter(lng)"
        :ref="
          selectedLanguage && lng.id == selectedLanguage.id ? 'selectedLng' : ''
        "
        :id="lng.id"
      >
        <flag-card
          :style="selectedLanguage ? 'opacity: 0.3' : ''"
          :name="lng.name"
          :flag="lng.id"
          :postulation="lng.postulation_program"
          :selected="selectedLanguage && lng.id == selectedLanguage.id"
        >
        </flag-card>
      </div>
    </div>
    <div v-else class="sk-languages">
      <div v-for="(n, index) in 10" :key="index" class="sk-flag-container">
        <v-skeleton-loader v-bind="attrs" type="image" class="sk-flag">
        </v-skeleton-loader>
        <v-skeleton-loader
          type="text"
          class="sk-name"
          v-bind="attrs"
        ></v-skeleton-loader>
      </div>
    </div>

    <language-programs
      v-if="isShow"
      @pup="mas($event)"
      @selected="selectProgram($event)"
      :items="programList"
      @close="
        selectedLanguage = null;
        isShow = false;
      "
      :style="{ marginTop: '-' + programListTop + 'px' }"
      @next="next()"
    >
    </language-programs>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title>
          <div class="flex-grow-1"></div>
          <v-btn icon @click="dialog = false">
            <v-icon class="iconColor">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="notifications_dialog_title" v-if="program">
          {{ program.name }}
        </v-card-text>
        <v-card-text
          class="notifications_dialog_body"
          v-if="program"
          v-html="program.modal_message"
        >
        </v-card-text>
        <!-- <v-card-text class="notifications_dialog_body">
                    <div class="notifications_dialog_detail mb-6 mt-3">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                    </div>
                    <div class="notifications_dialog_detail mb-6 mt-3">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                    </div>
                </v-card-text> -->
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import FlagCard from "@/components/language/FlagCard";
import LanguagePrograms from "@/containers/languages/LanguagePrograms";
import { mapMutations } from "vuex";
import jwt from "jwt-simple";

import axios from "@/axios-auth";

export default {
  components: {
    "flag-card": FlagCard,
    "language-programs": LanguagePrograms
  },
  data() {
    return {
      loading: true,
      isShow: false,
      dialog: false,
      user: null,
      languages: [],
      programList: [],
      program: null,
      selectedLanguage: null,
      selectedProgram: null,
      postulationList: [],

      programListTop: 0,
      postulation: null,

      attrs: {
        class: "mb-6",
        boilerplate: true
      }
    };
  },
  methods: {
    ...mapMutations(["setLanguage", "setProgram", "setPostulation"]),

    onFlagEnter(lng) {
      if (lng.enabled) {
        if (!lng.postulation_program) {
          this.selectedProgram = null;
          this.selectedLanguage = lng;
          this.programList = this.removeDuplicates(lng.program_list);

          if (this.programList.length) {
            this.isShow = true;
          }
        } else {
          // console.log(lng.postulation_program);

          let post = this.postulationList.find(
            s => s.program_id === lng.postulation_program.program_id
          );

          if (post) {
            // console.log(post);

            let prog = this.getProgramById(lng.program_list, post.program_id);

            // console.log(prog);

            this.setLanguage(lng);
            this.setProgram(prog);
            this.setPostulation(post);

            if (prog.require_survey && post.has_survey) {
              //no ha resuelto la encuesta
              this.$router.push({ path: `/poll` });
            } else {
              //postulación pendiente: antes de iniciar el examen
              this.goTo(post.status.id);
            }
          }
        }
      } else {
        alert(
          "Mostrar mensaje: Lo sentimos. Este curso no se esta dictando en este momento. Es probable que esté disponible más adelante."
        );
      }
    },
    goTo(statusId) {
      switch (statusId) {
        case 1: //postulación pendiente
          this.$router.push({ path: `/exam` });
          break;
        case 2: //debe resolver encuesta
          this.$router.push({ path: `/poll` });
          break;
        case 3: //evaluación en proceso
          this.$router.push({ path: `/evaluation` });
          break;
        case 4: //evaluación en finalizada
          this.$router.push({ path: `/evaluation/schedule` });
          break;
        case 5: //asesoria programada
          this.$router.push({ path: `/evaluation/schedule` });
          break;
        case 6: //asesoria terminada pero sin calificación
          this.$router.push({ path: `/evaluation/schedule/rate` });
          break;
        case 7: //proceso terminado
          this.$emit("status", "enrollment");
          this.$vuetify.goTo("#top", {
            duration: 0,
            offset: 0,
            easing: "linear"
          });
          break;
      }
    },
    removeDuplicates(originalArray) {
      //console.log(originalArray);
      var hash = {};
      originalArray = originalArray.filter(function(current) {
        let go =
          current.name !== undefined
            ? String(current.id) + String(current.name)
            : String(current.id);

        let exists = !hash[go] || false;

        hash[go] = true;

        return exists;
      });
      originalArray = originalArray.sort((x, y) =>
        x.name.localeCompare(y.name)
      );
      return originalArray;
    },
    getProgramById(programs, id) {
      return programs ? programs.find(p => p.id === id) : null;
    },
    selectProgram(p) {
      this.selectedProgram = p;
    },
    mas(p) {
      if (p) {
        this.program = p;
        this.dialog = true;
      }
    },
    loadLanguages() {
      axios
        .get(`languages/list/`, {
          headers: { Authorization: "Token " + this.user.token }
        })
        .then(response => {
          //console.log(response);
          return response.data;
        })
        .then(res => {
          //console.log(res);
          if (this.postulationList && res) {
            for (const lng of res) {
              for (const p of lng.program_list) {
                let r = this.postulationList.find(s => s.program_id === p.id);
                if (r) {
                  lng.postulation_program = r;
                  // lng.postulation_program = p.id;
                }
              }
            }
          }
          this.languages = res;
          this.loading = false;
        });
    },
    async registerPostulation() {
      let obj = {
        application_id:
          this.postulation != null ? this.postulation.id.toString() : "0",
        program: this.selectedProgram.id,
        up_user: this.user.username
      };
      await axios
        .post(`users/register-postulation/`, obj, {
          headers: { Authorization: "Token " + this.user.token }
        })
        .then(response => {
          if (this.postulation) {
            this.setRecords();
          } else {
            this.loadPostulation(response.data.application_id);
          }
          this.loading = false;
        })
        .catch(err => {
          console.error(err);
          this.loading = false;
        });
      let obj2 = {
        username: this.user.username
      };
      await axios
        .post(`users/student/`, obj2, {
          headers: { Authorization: "Token " + this.user.token }
        })
        .then(response => {
          if (response.data.student_id == "") {
            return;
          }
          var secret = this.secretKeyJwt;
          response.data.username = response.data.student_id;
          var token = jwt.encode(response.data, secret);
          console.log("token", token);
          if (token == null || token == undefined || token == "") {
            return;
          } else {
            this.$store.dispatch("guardarToken", {
              token: token,
              keyJwt: this.secretKeyJwt
            });
            this.$store.dispatch(
              "saveNotifications",
              response.data.notifications
            );
          }
        })
        .catch(err => {
          this.loading = false;
          //this.$store.dispatch("salir");
          console.log(err);
        });
    },
    loadPostulation(id) {
      let obj = {
        user_id: this.user.username,
        postulation_id: id
      };
      axios
        .post(`users/list-postulation/`, obj, {
          headers: { Authorization: "Token " + this.user.token }
        })
        .then(response => {
          // console.log(response.data);
          this.postulationList = response.data.detail;
          this.postulation = this.postulationList.find(
            s => s.program_id === ""
          );
          if (id == 0) {
            this.loadLanguages();
          } else {
            this.postulation = this.postulationList[0];
            this.setRecords();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    next() {
      if (this.selectedProgram && this.selectedLanguage) {
        this.registerPostulation();
      }
    },
    setRecords() {
      this.setLanguage(this.selectedLanguage);
      this.setProgram(this.selectedProgram);
      this.setPostulation(this.postulation);

      if (this.selectedProgram.require_survey) {
        this.$router.push({ path: `/poll` });
      } else if (this.selectedProgram.require_evaluation) {
        this.$router.push({ path: `/exam` });
      } else if (this.selectedProgram.require_interview) {
        this.$router.push({ path: `/evaluation/schedule` });
      } else {
        this.selectedLanguage = null;
        this.selectedProgram = null;
        this.isShow = false;
        this.loadPostulation(0);
        this.$emit("status", "enrollment");
      }
    }
  },
  mounted() {
    this.setLanguage(null);
    this.setProgram(null);
    this.setPostulation(null);
    this.user = this.$store.state.usuario;
    // console.log(this.user);
    this.loadPostulation(0);
  },
  watch: {
    selectedLanguage(val) {
      if (val) {
        setTimeout(() => {
          //console.log(this.$refs.selectedLng[0].offsetTop)
          const languageListHeight = this.$refs.languageList.clientHeight;
          const selectedLang = this.$refs.selectedLng[0];
          this.programListTop =
            languageListHeight -
            (selectedLang.offsetTop + selectedLang.clientHeight);
        }, 100);
      }
    }
  }
};
</script>
